import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import canvid from 'canvid';
import styleHelper from './../../../helpers/style';
import Spinner from './../../Spinner.jsx';
import actions from './../../../actions/small-card-actions';


class SmallInlineVideoCard extends React.Component {
  constructor(props) {
    super(props);

    // used by React as the component name
    this.displayName = 'SmallInlineVideoCard';

    // random unique id for video element
    this.randomId = (0 | Math.random() * 9e6).toString(36);

    // timeout to play video
    this.playVideoTimeout = 0;
  }


  /**
   * Called when component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this);
  }


  /**
   * Called when component unmounts
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    clearTimeout(this.playVideoTimeout);
    if (this.canvidControl &&
      typeof this.canvidControl.destroy === 'function') {
      this.canvidControl.destroy();
    }
  }


  /**
   * Called when component props or state updates
   * @param {Object} prevProps - The previous props
   * @returns {undefined} undefined
   */
  componentDidUpdate(prevProps) {
    const data = this.props.data;
    const state = this.props.smallCardFrameworkState;
    const prevState = prevProps.smallCardFrameworkState;
    const active = (state.currentCardIteration + 1 === data.order);
    const prevActive = (prevState.currentCardIteration + 1 === data.order);

    if (active && !prevActive) {
      const videoClass = '.vc-' + this.randomId;

      this.props.dispatch(actions.setLoading(true));

      this.playVideoTimeout = setTimeout(() => {
        this.canvidControl = canvid({
          selector: videoClass,
          videos: {
            clip1: {
              fps: data.fps,
              src: data.path,
              frames: data.frames,
              cols: data.columns,
            },
          },
          width: 750,
          height: 1334,
          loaded: () => {
            if (active) {
              this.canvidControl.play('clip1');
              setTimeout(() => {
                this.props.dispatch(actions.setLoading(false));
              }, 10);
            }
          },
        });
      }, 310);
    }

    if (!active) {
      clearTimeout(this.playVideoTimeout);
    }

    if (!active &&
      this.canvidControl &&
      typeof this.canvidControl.isPlaying === 'function' &&
      this.canvidControl.isPlaying()) {
      if (typeof this.canvidControl.destroy === 'function') {
        this.canvidControl.destroy();
      }
    }
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const data = this.props.data;
    const state = this.props.smallCardFrameworkState;
    const active = (state.currentCardIteration + 1 === data.order);
    let videoStyle = {};

    if (this.node) {
      videoStyle = styleHelper.getSizeToCover(
        data.size.width,
        data.size.height,
        this.node.offsetWidth,
        this.node.offsetHeight
      );
    }

    const videoWrapperStyle = {
      backgroundImage: 'url(' + this.props.data.coverPath + ')',
    };
    const activeClass = active ? ' active' : '';
    const videoClass = 'video-container vc-' + this.randomId;
    const className = 'card component-small-inline-video-card' + activeClass;

    return (
      <section
        className={className}
        style={this.props.style}
      >
        <div
          className='video-wrapper'
          style={videoWrapperStyle}
        >
          <div
            className={videoClass}
            style={videoStyle}
          />
        </div>
        <Spinner />
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Boolean} autoplay - If the video should autoplay
 * @prop {Object} data - An array of card React components
 * @prop {Function} dispatch - A Redux function to dispatch events
 * @prop {Number} iteration - The iteration of the component
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Boolean} showImageForUnsupportedAutoplay - If an image should be shown
 * if autoplaying video is not supported
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
SmallInlineVideoCard.propTypes = {
  autoplay: React.PropTypes.bool,
  data: React.PropTypes.object.isRequired,
  dispatch: React.PropTypes.func,
  iteration: React.PropTypes.number.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  showImageForUnsupportedAutoplay: React.PropTypes.bool,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, smallCardFrameworkState }))(SmallInlineVideoCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallInlineVideoCard.jsx
 **/